import BottomNav from "@/components/BottomNav";
import { Gift } from "lucide-react";

/**
 * P1 Fix 4 — Coming Soon placeholder for the Offers tab.
 * Kept deliberately minimal; the previous (non-functional) offers logic has
 * been removed. When the feature is launched, restore API calls from git
 * history and replace the body below.
 */
export default function CustomerOffers() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-cyan-50/20 flex flex-col">
      {/* Header */}
      <div className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl border-b border-slate-200 px-5 py-5 shadow-sm">
        <h1
          className="text-2xl font-black bg-gradient-to-r from-slate-900 to-[#1565C0] bg-clip-text text-transparent tracking-tight"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          Offers
        </h1>
      </div>

      {/* Coming soon body */}
      <div
        className="flex-1 flex flex-col items-center justify-center text-center px-6 pb-24"
        data-testid="offers-coming-soon"
      >
        <div className="text-6xl mb-4" role="img" aria-label="Gift">🎁</div>
        <h2
          className="text-2xl font-bold text-slate-900 mb-2"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          Coming Soon
        </h2>
        <p className="text-sm text-slate-600 max-w-xs leading-relaxed">
          Personalised loan offers and credit card recommendations will be
          available here soon.
        </p>
        <div className="mt-8 inline-flex items-center gap-2 bg-blue-100 text-[#1565C0] text-xs font-semibold px-4 py-2 rounded-full">
          <Gift className="h-3.5 w-3.5" />
          Stay tuned for exclusive deals
        </div>
      </div>

      <BottomNav />
    </div>
  );
}
